const sliderEl = document.querySelector('.custom-hero-slider__slider');

const autoplayValue = sliderEl?.dataset.autoplay;

const swiper = new Swiper('.custom-hero-slider__slider', {
  loop: true,
  speed: 1000,
  pagination: {
    el: '.custom-hero-slider__slider-pagination',
  },
  ...(autoplayValue
    ? {
        autoplay: {
          delay: parseInt(autoplayValue, 10),
          disableOnInteraction: false,
        },
      }
    : {}),
});
